import MConfig from "../Modules/MConfig";
import MRequest from "../Modules/MRequest";

export default class BProfileMessage
{
	constructor(el)
	{
		this.el = el;
	}

	static selector = () => `.profile-message`;

	static initialize()
	{
		this.addEventListeners();
	}

	static addEventListeners()
	{
		document.addEventListener("click", event => {
			const selector = `${this.selector()}__process-button`;
			if (event.target.matches(`${selector}, ${selector} *`)) {
				const message = new this(event.target.closest(this.selector()));
				const button = event.target.closest(selector);
				const url = MConfig.getRoute("api.v2.profile.messages.process");

				MRequest.post(url, {
					package: message.getPackage(),
					payload: JSON.parse(button.dataset.payload),
				}).then(response => {
					try {
						message.el.dataset.completed = response.data.completed ? 1 : 0;
					} catch (error) {
						// Nevermind.
					}
				});
			}
		});
	}

	getPackage()
	{
		return this.el.dataset.package;
	}
}
